import React from 'react';
import { motion } from 'framer-motion';
import { Quote as QuoteIcon } from 'lucide-react';
export function Quote() {
  return <section className="py-24 md:py-32 bg-navy relative overflow-hidden" data-id="element-188">
      {/* Background accents */}
      <div className="absolute top-0 left-0 w-full h-full opacity-10 pointer-events-none" data-id="element-189">
        <div className="absolute top-[-10%] left-[-5%] w-96 h-96 bg-red rounded-full blur-[100px]" data-id="element-190"></div>
        <div className="absolute bottom-[-10%] right-[-5%] w-96 h-96 bg-sky rounded-full blur-[100px]" data-id="element-191"></div>
      </div>

      <div className="max-w-5xl mx-auto px-6 md:px-12 relative z-10 text-center" data-id="element-192">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-193">
          <div className="flex justify-center mb-8" data-id="element-194">
            <QuoteIcon className="text-red opacity-50" size={64} strokeWidth={1} data-id="element-195" />
          </div>

          <h2 className="text-3xl md:text-5xl lg:text-6xl font-serif text-white leading-tight mb-12" data-id="element-196">
            "We need leaders who don't just talk about the struggles of working
            families, but who have{' '}
            <span className="text-sky italic" data-id="element-197">actually lived them.</span>"
          </h2>

          <div className="flex items-center justify-center gap-4" data-id="element-198">
            <div className="w-12 h-[1px] bg-red" data-id="element-199"></div>
            <span className="text-white font-medium tracking-widest uppercase text-sm" data-id="element-200">
              Delegate Elizabeth Guzmán
            </span>
            <div className="w-12 h-[1px] bg-red" data-id="element-201"></div>
          </div>
        </motion.div>
      </div>
    </section>;
}